import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const AddTask = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.2 4.97c0-.83.67-1.5 1.5-1.5h3.9a.5.5 0 0 0 0-1H3.7a2.5 2.5 0 0 0-2.5 2.5v7.06a2.5 2.5 0 0 0 2.5 2.5h6.8a2.5 2.5 0 0 0 2.5-2.5V7.91a.5.5 0 0 0-1 0v4.12c0 .83-.67 1.5-1.5 1.5H3.7a1.5 1.5 0 0 1-1.5-1.5V4.97Zm8.25 1.22a.5.5 0 1 0-.78-.63L6.32 9.8 4.76 8.24a.5.5 0 1 0-.71.7l1.96 1.96a.5.5 0 0 0 .74-.04l3.7-4.67Z"
        fill={color}
      />
      <path d="M12.5.5v4.94m-2.47-2.47h4.94" stroke={color} strokeLinecap="round" />
    </svg>
  )
})

export default AddTask
